var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndsSoonBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "50px",
    viewBox: "0 0 30 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Badge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L14,0 L14,6 C14,9.86599325 10.8659932,13 7,13 C3.13400675,13 3.13798288e-15,9.86599325 0,6 L0,0 L0,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "JOOR-Events---JAN-2021-Update",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hover-State-Colors",
    transform: "translate(-518.000000, -916.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ends-Soon",
    transform: "translate(493.000000, 591.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-5",
    transform: "translate(25.000000, 320.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Badge",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 L30,0 L30,0 L30,35 C30,43.2842712 23.2842712,50 15,50 C6.71572875,50 1.01453063e-15,43.2842712 0,35 L0,15 C-1.01453063e-15,6.71572875 6.71572875,1.52179594e-15 15,0 Z",
    id: "Rectangle",
    fill: "#5C7284"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 4,
    y: 4,
    width: 22,
    height: 42,
    rx: 11
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hourglass",
    transform: "translate(8.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,15 L13,15 L13,21 C13,22.6568542 12.3284271,24.1568542 11.2426407,25.2426407 C10.1568542,26.3284271 8.65685425,27 7,27 C5.34314575,27 3.84314575,26.3284271 2.75735931,25.2426407 C1.67157288,24.1568542 1,22.6568542 1,21 L1,21 L1,15 Z",
    id: "Rectangle",
    stroke: "#8C9BA8",
    strokeWidth: 2,
    transform: "translate(7.000000, 21.000000) scale(1, -1) translate(-7.000000, -21.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#8C9BA8",
    strokeWidth: 2,
    d: "M13,1 L13,6 C13,7.65685425 12.3284271,9.15685425 11.2426407,10.2426407 C10.1568542,11.3284271 8.65685425,12 7,12 C5.34314575,12 3.84314575,11.3284271 2.75735931,10.2426407 C1.67157288,9.15685425 1,7.65685425 1,6 L1,6 L1,1 L13,1 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#8C9BA8",
    x: 5,
    y: 11,
    width: 4,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    fill: "#0091FF",
    transform: "translate(7.000000, 14.000000) rotate(90.000000) translate(-7.000000, -14.000000) ",
    x: 6,
    y: 13,
    width: 2,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    fill: "#0091FF",
    transform: "translate(7.000000, 21.000000) rotate(90.000000) translate(-7.000000, -21.000000) ",
    x: 6,
    y: 18,
    width: 2,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    fill: "#0091FF",
    transform: "translate(7.000000, 18.000000) rotate(90.000000) translate(-7.000000, -18.000000) ",
    x: 6,
    y: 16,
    width: 2,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    fill: "#0091FF",
    transform: "translate(7.000000, 9.000000) rotate(90.000000) translate(-7.000000, -9.000000) ",
    x: 6,
    y: 7,
    width: 2,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-15",
    fill: "#0091FF",
    transform: "translate(7.000000, 24.000000) rotate(90.000000) translate(-7.000000, -24.000000) ",
    x: 6,
    y: 20,
    width: 2,
    height: 8,
    rx: 1
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndsSoonBadge);
export default __webpack_public_path__ + "static/media/ends_soon-badge.464981e8.svg";
export { ForwardRef as ReactComponent };